import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { DashboardGenerateNewRouterPasswordPage } from "@nju/feature-portal-user";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function MyProfile() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="ftth">
          <Navigation />
          <DashboardGenerateNewRouterPasswordPage />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
